import { SALES_ENDPOINT } from 'cfgCommon/endpoints'
import axios from 'axios'
import { BFFAgent } from '../../BFFAgent'
import { deepFreeze } from '../../../features/common/Utilities'

export async function getSale(saleId, params, perfil,editMode = false) {
  const { data: { data: sale } } = await axios(`${SALES_ENDPOINT}/${saleId}?editMode=${editMode}`)
  
  sale.reservation_discounts = JSON.parse(sale.reservation_discounts)
  sale.reservation_credits = JSON.parse(sale.reservation_credits)
  sale.discounts_pill = JSON.parse(sale.discounts_pill)

  const [cliente, auto] = await Promise.all([
    BFFAgent.Clients.getCliente(sale.client_id),
    BFFAgent.Catalogs.getAutoFull(sale.catalog_id, 'estadoStock=Activo&presupuesto=true', { perfil }),
  ])

  sale.cliente = cliente
  sale.auto = auto

  if(sale.stock_id) {
    const stock = await BFFAgent.Catalogs.getStock(sale.stock_id, `car_lot_id=${sale.car_lot_id}`);
    const {
      stock_vin,
      stock_color,
      stock_id,
      stock_sucursal,
      stock_ubicacion,
    } = sale;
  
    const selectedStock = {
      ...stock,
      vin: stock_vin,
      idColor: stock_color,
      id: stock_id,
      sucursal: stock_sucursal,
      ubicacion: stock_ubicacion,
      disponible: stock_vin ? 'FISICO' : 'A DEUDA',
    }
    sale.auto.Stocks.push(selectedStock);
  }

  for (const item of auto.Stocks) {
    const rule = sale?.reservation_discounts?.stock?.find(({id}) => id === item.id)
    item.monto = rule?.descuentoMaximo ? rule.descuentoMaximo : 0
    item.porcentaje = rule?.tomausado ? rule.tomausado : 0
  }

  return deepFreeze(sale)
}
